/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NAVIGATION_ROUTES } from './shared/constants/Constants';
import {
  getStringFromLS,
  getValueFromAppConfig,
} from './shared/helper-utils/localStorage';
import LoginPage from './features/login/LoginPage';
import LoginPageVoyra from './features/login/LoginPageVoyra';
import LoginPageVaya from './features/login/LoginPageVaya';
import FlightOneWaySearchResultsPage from './features/one-way/FlightOneWaySearchResultsPage';
import AgentRegistration from './features/profile/AgentRegistration';
import FlightRoundTripSearchResultsPage from './features/round-trip/FlightRoundTripSearchResultsPage';
import FlightRoundTripIntlSearchResultsPage from './features/roundt-trip-intl/FlightRoundTripIntlSearchResultsPage';
import FlightBookingPage from './features/flights/FlightBookingPage';
import ProfilePage from './features/profile/ProfilePage';
// import HotelLandingPage from './features/hotels/hotel-search/HotelLandingPage';
import HotelSearchResultsPage from './features/hotels/search-results/HotelSearchResultsPage';
import HotelDetailsPage from './features/hotels/hotel-details/HotelDetailsPage';
import BookingReviewPage from './features/hotels/booking-review/BookingReviewPage';
import BookingsListPage from './features/hotels/booking-details/BookingsListPage';
// import HotelInvoicePage from './features/hotels/booking-details/HotelInvoicePage';
import VoucherPage from './features/hotels/booking-details/Voucher';
// import ViewBookingDetailsPage from './features/hotels/booking-details/ViewBookingDetailsPage';
import FlightTicketPage from './features/flights/FlightTicketPage';
import ManageAllBookings from './features/manage-booking/ManageAllBookings';
import FlightHotelPassengerCalendar from './features/pax-calender/FlightHotelPassengerCalendar';
import FlightHoldQueues from './features/flights/FlightHoldQueues';
import MyBookingPage from './features/my-bookings/MyBookingsPage';
import FlightTicketInvoicePage from './features/flights/FlightTicketInvoicePage';
import FlightOrderDetailsPage from './features/flights/FlightOrderDetailsPage';
import AccountsPage from './features/profile/AccountsPage';
import ClientCommissions from './features/profile/client-commissions/ClientCommissions';
import BalanceUpload from './features/profile/BalanceUpload';
import AgentLedger from './features/profile/agent-ledger/AgentLedger';
import OfflineBalanceUpload from './features/profile/OfflineBalanceUpload';
import Reports from './features/profile/reports/Reports';
import StaffPage from './features/profile/staff/StaffPage';
import AgentMarkupPage from './features/profile/agent-markup/AgentMarkupPage';
import AgentSeriesFarePage from './features/profile/agent-series-fares/AgentSeriesFarePage';
import FlightReshedulePage from './features/manage-booking/FlightReshedulePage';
import FlightCancellation from './features/manage-booking/FlightCancellation';
import AboutUs from './features/static-pages/AboutUsPage';
import ContactUsPage from './features/static-pages/ContactUsPage';
import PrivacyPolicy from './features/static-pages/PrivacyPolicy';
import DisclaimerPage from './features/static-pages/DisclaimerPage';
import TermsAndConditionsPage from './features/static-pages/TermsAndConditionsPage';
import LandingPage from './features/landing/LandingPage';
import BusSearchResultsPage from './features/buses/search-results/BusSearchResultsPage';
import BusBookingReview from './features/buses/booking-review/BusBookingReview';
import BusBookingVoucherPage from './features/buses/booking-details/BusBookingVoucher';
import BusBookingVoucherInvoice from './features/buses/booking-details/BusBookingVoucherInvoice';
import BusBookingCancellationPage from './features/buses/booking-details/BusBookingCancellationPage';
import BusBookingCancellationDetails from './features/buses/booking-details/BusBookingCancellationDetails';
import BusCreditNote from './features/buses/booking-details/BusCreditNote';
import VisaPage from './features/visa/VisaPage';
// import InsurancePage from './features/visa/InsurancePage';
import TopupReceiptPage from './features/my-bookings/TopupReceiptPage';
import FlightRefundReceipt from './features/flights/FlightRefundReceipt';
import FlightDomesticMultiCityPage from './features/multi-city/FlightDomesticMultiCityPage';
import FlightDomMultiCityBookingPage from './features/multi-city/FlightDomMultiCityBookingPage';
import HotelCancellation from './features/hotels/cancel-booking/HotelCancellation';
import CreditDebitNoteReceipt from './features/profile/agent-ledger/CreditDebitNoteReceipt';
import HotelInvoice from './features/hotels/booking-details/HotelInvoice';
import FlightIntlMutiCItyResultsPage from './features/multi-city/FlightIntlMultiCityResultsPage';
import FlightGroupBooking from './features/group-booking/FlightGroupBooking';
import HotelBookingDetailsPage from './features/hotels/booking-details/HotelBookingDetailsPage';
import HotelNewVoucher from './features/hotels/booking-details/HotelNewVoucher';
import HotelCreditNote from './features/hotels/booking-details/HotelCreditNote';
import InsuranceVoucher from './features/my-bookings/InsuranceVoucher';
import FlightCustomerInvoicePage from './features/flights/FlightCustomerInvoicePage';
import { isEmpty, isMobileWidth } from './shared/helper-utils/appUtils';
import FlightBookingPageMobile from './features/flights/FlightBookingPageMobile';
import BulkInvoiceDownload from './features/flights/BulkInvoiceDownload';
import InsuranceVoucherNew from './features/my-bookings/InsuranceVoucherNew';
import OurValuesPage from './features/static-pages/OurValuesPage';
import HotelLandingPageV2 from './features/hotels/hotel-search/HotelLandingPageV2';
import InsurancePage from './features/visa/InsurancePage';
import CruiseDetails from './features/cruise/cruise-landingpage/CruiseDetails';
import CruiseCheckoutForm from './features/cruise/CruiseCheckoutForm';
import CabSearchResults from './features/cabs/search-results/CabSearchResults';
import CabsBookingPage from './features/cabs/booking/CabsBookingPage';
import CabsVoucher from './features/cabs/booking/CabsVoucher';
import { APP_USER_AUTH } from './saas/AppStorageStaticNames';
import NotFoundPage from './features/static-pages/NotFoundPage';
import { useAppContext } from './saas/AppConfigWrapper';
import InsurancePageNewV3 from './features/visa/InsurancePageNewV3';
import TboInsurance from './features/visa/TboInsurace';
import FlightResheduleRequestPageOfline from './features/manage-booking/FlightResheduleRequestPageOfline';
import FlightTicketInvoicePagev2 from './features/flights/FlightTicketInvoicePagev2';
import OnlineVisaRoutes from './features/online-visa/routes/OnlineVisaRoutes';
import EsimRoutes from './features/esim/routes/EsimRoutes';

export default function AppRoutes() {
  const { appConfig } = useAppContext();
  const checkAndRedirect = () => getStringFromLS(APP_USER_AUTH) === null;
  function RenderRoute({ children, notAuthorized, isAuthenticated }) {
    if (notAuthorized) {
      return <NotFoundPage />;
    }
    if (isAuthenticated && !isEmpty(getStringFromLS(APP_USER_AUTH))) {
      return children;
    }
    if (isAuthenticated && isEmpty(getStringFromLS(APP_USER_AUTH))) {
      return <Navigate to="/login" replace />;
    }
    if (!isAuthenticated) {
      return children;
    }
    return <NotFoundPage />;
  }
  return (
    <Routes>
      <Route exact path="" element={<Navigate to="/search" replace />} />
      <Route exact path="/" element={<Navigate to="/search" replace />} />
      <Route
        path={NAVIGATION_ROUTES.LANDING}
        element={
          <RenderRoute isAuthenticated>
            <LandingPage />
          </RenderRoute>
        }
      />
      <Route
        path="flight/owresults"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightOneWaySearchResultsPage />
          </RenderRoute>
        }
      />
      <Route path="/agent-registration" element={<AgentRegistration />} />
      <Route
        path="flight/rtresults"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightRoundTripSearchResultsPage />
          </RenderRoute>
        }
      />
      <Route
        path="/cruise/:slug"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasCruise !== true}
          >
            <CruiseDetails />
          </RenderRoute>
        }
      />
      <Route
        path="flight/rtintlresults"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightRoundTripIntlSearchResultsPage />
          </RenderRoute>
        }
      />
      <Route
        path="flight/book"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            {isMobileWidth() ? (
              <FlightBookingPageMobile />
            ) : (
              <FlightBookingPage />
            )}
          </RenderRoute>
        }
      />
      <Route
        path="flight/ticket/:transactionId"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightTicketPage />
          </RenderRoute>
        }
      />
      <Route
        path="flight/invoice/:transactionId"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            {appConfig?.companyName.toLowerCase() === 'sanram travels' ? (
              <FlightTicketInvoicePagev2 />
            ) : (
              <FlightTicketInvoicePage />
            )}
          </RenderRoute>
        }
      />
      <Route
        path="flight/customer-invoice/:transactionId"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightCustomerInvoicePage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_ORDER_DETAILS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightOrderDetailsPage />
          </RenderRoute>
        }
      />

      <Route
        path="/checkout"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasCruise !== true}
          >
            <CruiseCheckoutForm />
          </RenderRoute>
        }
      />

      <Route
        path={NAVIGATION_ROUTES.HOTEL.LANDING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelLandingPageV2 />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_SEARCH}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelSearchResultsPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_DETAILS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelDetailsPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.REVIEW_BOOKING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <BookingReviewPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.MANAGE_BOOKING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <BookingsListPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.BOOKING_DETAILS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelBookingDetailsPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.PRINT_TICKETS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelNewVoucher />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.VOUCHER}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <VoucherPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_GROUP_BOOKING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightGroupBooking />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.MANAGE_ALL_BOOKINGS}
        element={
          <RenderRoute isAuthenticated>
            <ManageAllBookings />
          </RenderRoute>
        }
      />
      <Route
        path="profile"
        element={
          <RenderRoute isAuthenticated>
            <ProfilePage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.PASSENGER_CALENDER}
        element={
          <RenderRoute isAuthenticated>
            <FlightHotelPassengerCalendar />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_RESHEDULE_PAGE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            {appConfig?.hasResheduleOfline === true ? (
              <FlightResheduleRequestPageOfline />
            ) : (
              <FlightReshedulePage />
            )}
          </RenderRoute>
        }
      />

      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_CANCELLATION_PAGE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightCancellation />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_BOOKING_CALENDAR}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <FlightHotelPassengerCalendar type="Hotel" />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_HOLD_QUEUES}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightHoldQueues />
          </RenderRoute>
        }
      />
      <Route
        path="my-bookings"
        element={
          <RenderRoute isAuthenticated>
            <MyBookingPage />
          </RenderRoute>
        }
      />
      <Route
        path="accounts"
        element={
          <RenderRoute isAuthenticated>
            <AccountsPage />
          </RenderRoute>
        }
      />
      <Route
        path="/client-commissions"
        element={
          <RenderRoute isAuthenticated>
            <ClientCommissions />
          </RenderRoute>
        }
      />
      <Route
        path="/make-payment"
        element={
          <RenderRoute isAuthenticated>
            <OfflineBalanceUpload />
          </RenderRoute>
        }
      />
      <Route
        path="profile/ledger"
        element={
          <RenderRoute isAuthenticated>
            <AgentLedger />
          </RenderRoute>
        }
      />
      <Route
        path="balance-upload"
        element={
          <RenderRoute isAuthenticated>
            <BalanceUpload />
          </RenderRoute>
        }
      />
      <Route
        path="reports"
        element={
          <RenderRoute isAuthenticated>
            <Reports />
          </RenderRoute>
        }
      />
      <Route
        path="staff"
        element={
          <RenderRoute isAuthenticated>
            <StaffPage />
          </RenderRoute>
        }
      />
      <Route
        path="agent-markup"
        element={
          <RenderRoute isAuthenticated>
            <AgentMarkupPage />
          </RenderRoute>
        }
      />
      <Route
        path="/agent-coupon-master"
        element={
          <RenderRoute isAuthenticated>
            <AgentSeriesFarePage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.BUS_SEARCH}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusSearchResultsPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.REVIEW_BOOKING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusBookingReview />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.PRINT_TICKETS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusBookingVoucherPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.BUS_INVOICE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusBookingVoucherInvoice />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.BOOKING_CANCEL}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusBookingCancellationPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.BOOKING_CANCEL_DETAILS}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusBookingCancellationDetails />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.BUS.BUS_CREDIT_NOTE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasBus !== true}
          >
            <BusCreditNote />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.TOP_UP_RECEIPT}
        element={
          <RenderRoute isAuthenticated>
            <TopupReceiptPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.FLIGHT_REFUND_RECEIPT}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightRefundReceipt />
          </RenderRoute>
        }
      />
      <Route
        path="/visa"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasVisa !== true}
          >
            <VisaPage />
          </RenderRoute>
        }
      />
      <Route
        path="/insurance"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasInsurance !== true}
          >
            {getValueFromAppConfig('INSURANCETYPE') === 'dolphininsurance' ? (
              <InsurancePageNewV3 />
            ) : getValueFromAppConfig('INSURANCETYPE') === 'tbo' ? (
              <TboInsurance />
            ) : (
              <InsurancePage />
            )}
          </RenderRoute>
        }
      />
      <Route
        path="/flight/dom-multicity"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightDomesticMultiCityPage />
          </RenderRoute>
        }
      />
      <Route
        path="/flight/book-multi-city"
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightDomMultiCityBookingPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_CANCELLATION}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelCancellation />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.CREDIT_DEBIT_NOTE}
        element={
          <RenderRoute isAuthenticated>
            <CreditDebitNoteReceipt />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_INVOICE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelInvoice />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.FLIGHT.INTL_MULTICITY_RESULTS_ROUTE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasFlight !== true}
          >
            <FlightIntlMutiCItyResultsPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.HOTEL.HOTEL_CREDIT_NOTE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasHotel !== true}
          >
            <HotelCreditNote />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.INSUARNCE_INVOICE}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasInsurance !== true}
          >
            <InsuranceVoucher />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.INSUARNCE_VOUCHER}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasInsurance !== true}
          >
            <InsuranceVoucherNew />
          </RenderRoute>
        }
      />
      <Route
        path="/bulk-invoice"
        element={
          <RenderRoute isAuthenticated>
            <BulkInvoiceDownload />
          </RenderRoute>
        }
      />

      <Route
        path={NAVIGATION_ROUTES.CABS.CABS_SEARCH}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasCab !== true}
          >
            <CabSearchResults />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.CABS.REVIEW_BOOKING}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasCab !== true}
          >
            <CabsBookingPage />
          </RenderRoute>
        }
      />
      <Route
        path={NAVIGATION_ROUTES.CABS.CABS_VOUCHER}
        element={
          <RenderRoute
            isAuthenticated
            notAuthorized={appConfig?.hasCab !== true}
          >
            <CabsVoucher />
          </RenderRoute>
        }
      />
      {appConfig?.hasOnlineVisa && OnlineVisaRoutes()}
      {appConfig?.hasEsimfast && EsimRoutes()}
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUsPage />} />
      <Route path="/our-values" element={<OurValuesPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/disclaimer" element={<DisclaimerPage />} />
      <Route path="/terms-conditions" element={<TermsAndConditionsPage />} />
      <Route
        path="login"
        element={
          checkAndRedirect() ? (
            appConfig?.appDbName?.toLowerCase() === 'saas_voyrainr' ? (
              <LoginPageVoyra />
            ) : appConfig?.appDbName?.toLowerCase() === 'saas_vaya' ? (
              <LoginPageVaya />
            ) : (
              <LoginPage />
            )
          ) : (
            <Navigate to="/search" replace />
          )
        }
      />
    </Routes>
  );
}
